import React, { useState, useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import "./pincity.css";
import logoimage from './assets/ajlogo2026.png';
mapboxgl.accessToken =
  "pk.eyJ1IjoiYWpqZXJ1c2FsZW0iLCJhIjoiY2l4b2t3N2lyMDAxMzJxcHMwZ3IzOWN1OSJ9.cxZW0ZgGPFDZpc_-JtRBxg";
// Cities list
const cities = [{"name":"Where is the country's capital?","lat":33.886815,"lon":35.494156,"blurb":"With some 2.4 million inhabitants, Greater Beirut is home to 40 percent of the country’s 5.9 million people.","Category":"zero"},{"name":"Where is the Rafic Hariri international airport?","lat":33.826778,"lon":35.490929,"blurb":"Located 9km (6 miles) south of Beirut's city centre, it is currently the only operational commercial airport in Lebanon.","Category":"one"},{"name":"Where is the Masnaa-Jdeidet Yabous border crossing with Syria?","lat":33.67435,"lon":35.964795,"blurb":"The crossing, located in the Bekaa Valley, remains the most significant for commercial transit and passenger travel between the two countries.","Category":"two"},{"name":"Which city features a Roman-era hippodrome and Egyptian port?","lat":33.269806,"lon":35.196794,"blurb":"The southern coastal city of Tyre (Sour) is one of the oldest continuously inhabited cities in the world. Among its landmarks are the 4,000‑year‑old Egyptian port and the world's second‑largest hippodrome, built for chariot racing in the second century.","Category":"three"},{"name":"Where is the sprawling urban district known as Dahiyeh?","lat":33.849635,"lon":35.510247,"blurb":"Dahiyeh (Arabic for suburb) refers to the southern suburbs of Beirut, a densely populated urban area located between Beirut city and the Baabda district.","Category":"one"},{"name":"Where is the highest waterfall in Lebanon?","lat":34.170303,"lon":35.869977,"blurb":"The Baatara gorge waterfall, located 75km (47 miles) from Beirut, drops 90 to 100 metres (300-330 feet), falling into a sinkhole that reaches a total depth of 255 metres (837 feet).","Category":"four"},{"name":"Where is the Museum of Resistance (Mleeta Museum) located?","lat":33.45643867,"lon":35.52564013,"blurb":"Located in the south near the village of Mleeta, the war museum opened in 2010 to commemorate the Israeli withdrawal in 2000, which ended a 22-year occupation of Lebanon.","Category":"three"},{"name":"Where are the Sisters Olive Trees of Noah?","lat":34.201598,"lon":35.823244,"blurb":"Located in the mountain village of Bchaaleh, the grove consists of 16 olive trees that, according to local folklore, are at least 5,000 years old and still produce olives.","Category":"four"},{"name":"Where is Lebanon's second-largest city, also known as the \"Capital of the North\"?","lat":34.436436,"lon":35.833848,"blurb":"Located along the Mediterranean coast, the ancient city - with a metropolitan population of about 700,000 - is known for its Mamluk architecture and rich scholarly history.","Category":"two"},{"name":"Where is Ein el-Hilweh, Lebanon's largest Palestinian refugee camp?","lat":33.543577,"lon":35.377848,"blurb":"Located on the outskirts of Sidon in the south, the refugee camp was established in 1948 to accommodate Palestinian refugees displaced during the Nakba.","Category":"five"},{"name":"Where are some of the best-preserved Roman ruins in the world?","lat":34.0057342,"lon":36.2114849,"blurb":"The UNESCO World Heritage Site is located in Baalbek, home to the Temple of Jupiter and the Temple of Bacchus.","Category":"three"},{"name":"Where is the 12th-century Beaufort Castle?","lat":33.323925,"lon":35.532072,"blurb":"This Crusader fortress, known locally as Qalaat al-Shaqif, is perched on a 700-metre (2,300-foot) cliff overlooking the Litani River near the village of Arnoun in the Nabatieh governorate.","Category":"two"},{"name":"Where is the 15-tonne bronze statue of the Virgin Mary?","lat":33.981809,"lon":35.651567,"blurb":"The most prominent Marian shrine in the Middle East is located at the Shrine of Our Lady of Lebanon in Keserwan-Jbeil governorate’s Harissa village.","Category":"two"},{"name":"Where is the largest ski destination in the Middle East?","lat":33.992495,"lon":35.843232,"blurb":"Mzaar Kfardebian, located in the mountains about an hour away from Beirut, features 42 slopes and a 2,465-metre (8,090-foot) peak at Mount Mzaar.","Category":"four"},{"name":"Where are the headquarters of UNIFIL?","lat":33.121488,"lon":35.134147,"blurb":"Located in Naqoura, the United Nations Interim Force in Lebanon is an international peacekeeping mission that has operated in southern Lebanon since 1978.","Category":"five"},{"name":"Where is the ancient cedar forest depicted on the Lebanese flag?","lat":34.24359,"lon":36.048865,"blurb":"The Cedars of God (Arz el-Rab) in the Qadisha Valley in northern Lebanon are a UNESCO World Heritage Site. Some of the trees there are estimated to be more than 1,000 years old.","Category":"four"},{"name":"Which is the largest city in southern Lebanon by population?","lat":33.557043,"lon":35.374796,"blurb":"Sidon, the ancient Phoenician city, is the third-largest city in Lebanon after Beirut and Tripoli, with a metropolitan population exceeding 250,000.","Category":"five"},{"name":"Where are the Sabra neighbourhood and the Shatila refugee camp?","lat":33.86395,"lon":35.499106,"blurb":"Located south of Beirut, Sabra and Shatila were the sites of the 1982 massacre in which Israeli-backed Phalange militias killed between 2,000 and 3,500 Palestinian refugees and Lebanese civilians in two days.","Category":"three"},{"name":"Where did the catastrophic port explosion of August 2020 occur?","lat":33.9004,"lon":35.518255,"blurb":"On August 4, 2020, a massive explosion at Beirut's port - caused by 2,750 tonnes of improperly stored ammonium nitrate - killed more than 200 people, injured thousands and devastated large parts of the capital.","Category":"zero"},{"name":"Where is the scenic mountain town of Jezzine?","lat":33.540113,"lon":35.585246,"blurb":"Located in southern Lebanon, the popular tourist destination is known for its dramatic cliffs, pine forests and a distinctive artisanal handcraft.","Category":"five"}];


// Shuffle helper
// function shuffleArray(array) {
//   return [...array].sort(() => Math.random() - 0.5);
// }

function shuffleArray(array) {
  const result = [...array];

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
}

function getRandomCities(cities, total = 10) {
  const byCountry = {};


  cities.forEach(c => {
    (byCountry[c.Category] ||= []).push(c);
  });

  const picked = Object.values(byCountry).map(
    group => group[Math.floor(Math.random() * group.length)]
  );

  const remaining = cities.filter(c => !picked.includes(c));
  const extra = shuffleArray(remaining).slice(0, total - picked.length);
  return shuffleArray([...picked, ...extra]);
  
}

// Haversine function
function haversine(lat1, lon1, lat2, lon2) {
  const toRad = (deg) => (deg * Math.PI) / 180;
  const R = 6371; // Earth radius in km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

export default function PinTheCity() {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const markerRefs = useRef([]);

  // const [shuffledCities, setShuffledCities] = useState(() => {
  //   // Select a random 10 cities
  //   return shuffleArray(cities).slice(0, 10);
  // });


  const [shuffledCities, setShuffledCities] = useState(() =>
  getRandomCities(cities, 10)
);


  const [cityIndex, setCityIndex] = useState(0);
  const [guess, setGuess] = useState(null);
  const [score, setScore] = useState(0);
  const [totalScore, setTotalScore] = useState(0);
  const [revealed, setRevealed] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [showFinalScoreButton, setShowFinalScoreButton] = useState(false);

  const [closestCity, setClosestCity] = useState(null);
  const [minDistance, setMinDistance] = useState(null);

  const city = shuffledCities[cityIndex];
  const correct = { lat: city.lat, lon: city.lon };

  // Calculate progress percentage
  const progress = (totalScore/100)*100;


  // Function to determine zoom level based on screen size
function getZoomLevel() {
    const width = window.innerWidth; // Get the width of the window
    if (width <= 480) return 7.5; // Mobile devices
    if (width > 480 && width <= 768) return 7.8; // Tablets
    if (width > 768 && width <= 1120) return 7.9; // Tablets
    return 8.2; // Desktops
}

const mymapBounds = [
    [32.455012,30.059969],  // Southwest: 
    [39.070602,36.354869 ] // Northeast: 
];
  
  useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/ajjerusalem/cmo78um1b003801s6gubv2923",
        center: [35.852339, 33.865279],
        zoom: getZoomLevel(), // Set zoom level based on screen size
        minZoom: 7,
        maxZoom: 9.5,
        interactive: true,
        maxBounds:mymapBounds
      });

      mapRef.current.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');

      
      mapRef.current.on("click", (e) => {
        if (!revealed) {
          const { lng, lat } = e.lngLat;
          let closest = null;
          let minDist = Infinity;

          cities.forEach((city) => {
            const distance = haversine(lat, lng, city.lat, city.lon);
            if (distance < minDist) {
              minDist = distance;
              closest = city;
            }
          });

          setClosestCity(closest);
          setMinDistance(minDist);
          setGuess({ lat, lon: lng });
        }
      });

      // mapRef.current.on("load", () => {
      //   mapRef.current.addSource("my-image", {
      //     type: "image",
      //     url: process.env.PUBLIC_URL + "/mapo.png",
      //     coordinates: [
      //       [34.2, 33.3],
      //       [35.7, 33.3],
      //       [35.7, 29.477],
      //       [34.2, 29.477],
      //     ],
      //   });

      //   mapRef.current.addLayer({
      //     id: "image-layer",
      //     type: "raster",
      //     source: "my-image",
      //     paint: { "raster-opacity": 1 },
      //   });
      // });
      mapRef.current.getCanvas().style.cursor = 'default';

      mapRef.current.on('mouseleave', () => {
        mapRef.current.getCanvas().style.cursor = 'default'; // Reset to normal cursor
      });
    }
  }, [revealed]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    markerRefs.current.forEach((marker) => marker.remove());
    markerRefs.current = [];

    if (guess) {
      const guessMarker = new mapboxgl.Marker({ color: "red" })
        .setLngLat([guess.lon, guess.lat])
        .addTo(map);
      markerRefs.current.push(guessMarker);
    }

    if (revealed) {
      const correctMarker = new mapboxgl.Marker({ color: "green" })
        .setLngLat([correct.lon, correct.lat])
        .addTo(map);
      markerRefs.current.push(correctMarker);
    }
  }, [guess, revealed]);

  const revealAnswer = () => {
    if (!guess) return;
    const distance = haversine(guess.lat, guess.lon, correct.lat, correct.lon);
    let roundScore = 0;
    if (distance < 7) roundScore = 10;
    else if (distance < 10) roundScore = 9;
    else if (distance < 18) roundScore = 8;
    else if (distance < 26) roundScore = 7;
    else if (distance < 35) roundScore = 6;
    else if (distance < 43) roundScore = 5;
    else if (distance < 55) roundScore = 3;
    else if (distance < 70) roundScore = 2;
    else roundScore = 0;

    setTotalScore((prev) => prev + roundScore);
    setScore(roundScore);
    setRevealed(true);
  
    if (cityIndex === shuffledCities.length - 1) {
      setShowFinalScoreButton(true); // Prepare to show final score
    }
  };

  const nextRound = () => {
    const nextIndex = cityIndex + 1;

    if (nextIndex >= shuffledCities.length) {
      setGameOver(true);
    } else {
      setCityIndex(nextIndex);
      setGuess(null);
      setRevealed(false);
    }
  };

  const restartGame = () => {
    setShuffledCities(getRandomCities(cities, 10));  // Limit to 10 cities again
    setGameOver(false);
    setCityIndex(0);
    setTotalScore(0);
    setScore(0);
    setGuess(null);
    setRevealed(false);
  };


  const tweetText = `How well do you know Lebanon? I scored ${totalScore}/100. @AJEnglish @AJLabs - play here: https://aljazeera.com/lebanonquiz`;
  const whatsText= `How well do you know Lebanon? I scored ${totalScore}/100. @AJEnglish @AJLabs — play here: https://aljazeera.com/lebanonquiz`;
  const tweeturl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
  const whatsurl = `whatsapp://send?text=${encodeURIComponent(whatsText)}`;

  return (
    <div className=" relative w-full h-screen flex flex-col items-center p-4">



<div className="centerbarx flex flex-col items-center">
<div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
  {

    <a href="https://aljazeera.com" target="_blank" rel="noopener noreferrer">
      <img
        src={logoimage}
        alt="Al Jazeera"
        style={{ width: "94px", height:"auto" }}
      />
    </a>
    
  }
  </div>
</div> 

{/* Progress Bar + Counter */}
<div className="rightbarx flex flex-col items-center">
  {/* Counter Text */}
  <div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
    Score: {totalScore}/100
  </div>

  {/* Progress Bar */}
  {/* <div className="rightbar w-3 bg-gray-300 rounded-lg overflow-hidden">
    <div
      className="bg-blue-500 w-full transition-all duration-300"
      style={{ height: `${progress}%` }}
    ></div>
  </div> */}
</div>



<div className="leftbarx flex flex-col items-center">
  {/* Counter Text */}
  <div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
    Question: {cityIndex+1}/{shuffledCities.length}
  </div>
</div>

      {/* Main Content */}
      <p className="text-center whereis font-bold mb-2">
      </p>
      <p className="text-center cityguess">{city.name}</p>
      <p className="text-guess pad-bottom text-center font-bold mb-2">
        Drop a pin 📍 on the map 🌍 to guess
      </p>

      <div
        ref={mapContainer}
        style={{ height: "80vh", width: "100%" }}
        className="mb-4"
      />
      {/* Move the submit button right under the city name */}
      {!revealed && (
          
        <div className="submitbutton text-center mb-4">
               <div> <p className="text-guess pad-bottom text-center font-bold mb-2">
        Drop a pin 📍 on the map 🌍 to guess
      </p>
          <button
            className="buttonguess mt-2 px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
            onClick={revealAnswer}
            disabled={!guess}
          >
            Submit guess
          </button>
        </div>
        </div>
      )}


      {revealed && (
        <div className="popupbox inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="popupin bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-center">
          {!gameOver ? (
            <div><p className="text-lg strong mb-2">
              Your guess is{" "}
              {Math.round(
                haversine(guess.lat, guess.lon, correct.lat, correct.lon)
                ).toLocaleString()} km
              (
              {Math.round(
                haversine(guess.lat, guess.lon, correct.lat, correct.lon) / 1.61
                ).toLocaleString()} 
              {" "} miles away)
        {/* from {city.name}  */}
        {/* {closestCity && closestCity.name !== city.name && minDistance !== null && (
                <span className="mt-4 text-sm text-gray-700">, but only {Math.round(minDistance)}km from {closestCity.name}</span>
            )} */}
      </p>
      <p className="mb-1 score-text">You scored {score} points!</p>
          
          <p className="blurbtext">{city.blurb}</p>
          </div>
                ) : (<div></div>)}

            {gameOver ? (
              <div>
                <h2 className="text-xl font-semibold mb-2">Game Over!</h2>
                <p className="mb-4 totalscore">Your total score is: {totalScore}/100</p>

                <p>SHARE YOUR SCORE</p>
                <section className="combined-share__links text-center">
            
                          <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Faljazeera.com%2Flebanonquiz%2F">
                            <svg className="icon icon--facebook icon--social icon--24 " viewBox="0 0 20 20" version="1.1" aria-hidden="true"><title>facebook</title><path className="icon-main-color" d="M10,0 C4.47714844,0 0,4.47714844 0,10 C0,14.9912891 3.65685547,19.1283203 8.4375,19.8785157 L8.4375,12.890625 L5.8984375,12.890625 L5.8984375,10 L8.4375,10 L8.4375,7.796875 C8.4375,5.290625 9.93042967,3.90625 12.2146484,3.90625 C13.3087305,3.90625 14.453125,4.1015625 14.453125,4.1015625 L14.453125,6.5625 L13.1921484,6.5625 C11.9499023,6.5625 11.5625,7.33333984 11.5625,8.12416016 L11.5625,10 L14.3359375,10 L13.8925782,12.890625 L11.5625,12.890625 L11.5625,19.8785157 C16.3431445,19.1283203 20,14.9912891 20,10 C20,4.47714844 15.5228516,0 10,0 Z"></path></svg>
                          </a>
                          <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Twitter" href={tweeturl}>
                            <svg className="icon icon--twitter icon--social icon--24 " viewBox="0 0 26 24" version="1.1" aria-hidden="true"><title>twitter</title><path className="icon-main-color" fillRule="evenodd" d="m.063 0 10.039 13.237L0 24h2.273l8.845-9.423L18.263 24H26L15.397 10.018 24.799 0h-2.273l-8.145 8.678L7.801 0H.062Zm3.344 1.652H6.96l15.695 20.696h-3.554L3.407 1.652Z"></path></svg>
                          </a>
                          <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Whatsapp" href={whatsurl}>
                            <svg className="icon icon--whatsapp icon--social icon--24 " viewBox="0 0 20 20" version="1.1" aria-hidden="true"><title>whatsapp</title><path className="icon-main-color" d="M19 9.74a9.54 9.54 0 0 1-9.33 9.74 9 9 0 0 1-4.51-1.21L0 20l1.68-5.23a10 10 0 0 1-1.33-5A9.53 9.53 0 0 1 9.62 0 9.54 9.54 0 0 1 19 9.74zM14.33 12c-.05-.1-.21-.16-.44-.28s-1.35-.7-1.56-.78-.36-.12-.51.12a11.45 11.45 0 0 1-.73.94c-.13.16-.26.18-.49.06a6.28 6.28 0 0 1-1.84-1.19 7 7 0 0 1-1.27-1.66.35.35 0 0 1 .1-.49c.1-.11.23-.28.34-.42a1.6 1.6 0 0 0 .23-.4.42.42 0 0 0 0-.41c-.06-.12-.51-1.3-.7-1.78s-.39-.4-.52-.4H6.5a.83.83 0 0 0-.61.3 2.74 2.74 0 0 0-.8 2A4.63 4.63 0 0 0 6 10.05a9.54 9.54 0 0 0 3.9 3.61c2.33 1 2.33.64 2.75.6a2.33 2.33 0 0 0 1.54-1.14 2 2 0 0 0 .14-1.12z"></path></svg>
                          </a>

                        </section>
                <button
                  className="buttonguess px-4 py-2 bg-blue-600 text-white rounded"
                  onClick={restartGame}
                >
                  PLAY AGAIN
                </button>
              </div>
            ) : (
              <button
                className="buttonguess padit px-4 py-2 bg-green-600 text-white rounded"
                onClick={nextRound}
              >
                Next
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
